"use client"

import { MessageCircle } from "lucide-react"
import { usePathname } from "next/navigation"
import type { DomainConfig } from "@/lib/domain"
import { cn } from "@/lib/utils"
import { useTranslations } from "@/lib/i18n/client"

export function WhatsAppButton({ domainConfig }: { domainConfig: DomainConfig }) {
  const pathname = usePathname()
  const { t } = useTranslations()

  if (!domainConfig.whatsappNumber) return null

  // No detalhe de aeronave (/aeronaves/<slug>) já existe uma bottom bar fixa de WhatsApp em mobile.
  // Esconde o flutuante em mobile pra evitar dois CTAs WhatsApp empilhados; mantém visível em desktop.
  const isAircraftDetail =
    pathname.startsWith("/aeronaves/") && pathname !== "/aeronaves"

  const message = encodeURIComponent(domainConfig.whatsappText)

  return (
    <a
      href={`https://wa.me/${domainConfig.whatsappNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "whatsapp-pulse fixed right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white transition-transform hover:scale-105",
        isAircraftDetail && "hidden md:flex",
      )}
      style={{ bottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}
      aria-label={t.common.whatsappFloatingAriaLabel}
    >
      <MessageCircle className="h-7 w-7" aria-hidden="true" />
    </a>
  )
}
